import { render, staticRenderFns } from "./TaxonomyField.vue?vue&type=template&id=6d9e2a33&"
import script from "./TaxonomyField.vue?vue&type=script&lang=js&"
export * from "./TaxonomyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9e2a33')) {
      api.createRecord('6d9e2a33', component.options)
    } else {
      api.reload('6d9e2a33', component.options)
    }
    module.hot.accept("./TaxonomyField.vue?vue&type=template&id=6d9e2a33&", function () {
      api.rerender('6d9e2a33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/components/fields/TaxonomyField.vue"
export default component.exports